import { gql } from 'graphql-request'

class CustomerUserMutations {
  createCustomerUser = gql`
    mutation CreateCustomerUser($data: CustomerUserCreateInput!) {
      createCustomerUser(data: $data) {
        id
      }
    }
  `

  updateCustomerUser = gql`
    mutation UpdateCustomerUser($where: CustomerUserWhereUniqueInput!, $data: CustomerUserUpdateInput!) {
      updateCustomerUser(where: $where, data: $data) {
        user {
          displayName
          email
        }
        role
        assignedPlaces {
          id
          name
        }
        customer {
          id
        }
        createdAt
      }
    }
  `

  deleteCustomerUser = gql`
    mutation DeleteCustomerUser($where: CustomerUsersWhereIdsInput!) {
      deleteCustomerUsers(where: $where) {
        count
      }
    }
  `
}

const customerUserMutations = new CustomerUserMutations()

export default customerUserMutations
